import { Box } from "@mui/material";
import { DEFAULT_SIDEPANEL_WIDTH } from "@styles/common-styles";
import { ReactElement, ReactNode } from "react";

interface Props {
  /** The status of the side panel  */
  isSidePanelOpened?: boolean;

  /** The size of the side panel  */
  sidePanelContentWidth?: string | number;

  /** The component that will render for the side panel  */
  sidePanelContent?: ReactNode;
}

/**
 * Component for rendering a side panel in the Faro Table
 */
export function FaroTableSidePanel({
  isSidePanelOpened = false,
  sidePanelContentWidth = DEFAULT_SIDEPANEL_WIDTH,
  sidePanelContent,
}: Props): ReactElement | null {
  if (!sidePanelContent) {
    return null;
  }

  return (
    <Box
      sx={{
        overflow: "hidden",
        opacity: isSidePanelOpened ? 1 : 0,
        visibility: isSidePanelOpened ? "visible" : "hidden",
        width: isSidePanelOpened ? `${sidePanelContentWidth}px` : "0",
        transition: "0.3s ease-in-out",
        mt: "55px",
      }}
    >
      {sidePanelContent}
    </Box>
  );
}
